import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引用vant组件 懒加载lazyload
import Vant, { Lazyload } from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
Vue.use(Lazyload, {lazyComponent: true});

// request封装
import request from '@/utils/request.js';
Vue.prototype.$request = request;

// 360设计图自适应
import "./utils/rem.js"

import './permission.js'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
